import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {  Link } from 'react-router-dom';
import { AiFillDelete } from "react-icons/ai";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import useFetchWithAuthorization from '../Apis/useFetchWithAuthorization';


const BuyerOrders = () => {
    const navigate= useNavigate();
 const [orders, setOrders]=useState([])
  const { data:order, loading:pending, error } = useFetchWithAuthorization('https://campus-closet-server.vercel.app/api/Buyer/orders');
  useEffect(()=>{
    setOrders(order)
  },[order])
  if (pending) {
    return <div style={{ height: `calc(100vh - 100px)` }} className='flex justify-center'>Loading...</div>; // Display a loading state while fetching orders
  }
  if (error && error === "Unauthorized") {
    return(
    <div style={{ height: `calc(100vh - 100px)` }} className=" flex justify-center">
      <div>
        <h1>Unauthorized Access</h1>
        <button onClick={()=>navigate('/login')} className={`w-full text-gray-900 bg-blue-400 hover:bg-blue-500 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center`} >Login</button>
      </div>
  </div>)
  }
  if (error) {
    return <div style={{ height: `calc(100vh - 100px)` }}>Error occured. Try again later: {error}</div>; // Display an error message if the fetching fails
  }

  // // Handle delete functionality
  // const handleDelete = (oid) => {
  //   console.log(oid);
  //   // Display a confirmation dialog to the user
  //   if (window.confirm("Are you sure you want to delete this order?")) {
  //     fetch(`https://campus-closet-server.vercel.app/orders/${oid}`, {
  //       method: "DELETE",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //     })
  //       .then((response) => response.json())
  //       .then((data) => {
  //       setOrders((prevOrders) => prevOrders.filter((order) => order.oid !== oid));
  //           console.log("Item deleted successfully!");; // Handle the response data
  //         // Perform any additional actions after successful deletion
  //         toast.success("order deleted successfully!", {
  //           position: toast.POSITION.TOP_CENTER,
  //           autoClose: 1000,
  //         });
  //         // Remove the deleted item from yourData array
  //         setOrders((prevData) => prevData.filter((item) => item.oid !== oid));
  //       })
  //       .catch((error) => {
  //         console.error(error); // Handle the error
  //         // Perform any error handling or display error messages
  //         toast.error("Error deleting the product. Please try again later.", {
  //           position: toast.POSITION.TOP_CENTER,
  //           autoClose: 1000,
  //         });
  //       });
  //   }
  // };


  const handleDelete = (oid) => {
    console.log(oid);
    // Display a confirmation dialog to the user
    if (window.confirm("Are you sure you want to delete this order?")) {
      const maxRetries = 3; // Define the maximum number of retry attempts
      let retryCount = 0;
  
      const executeDelete = () => {
        fetch(`https://campus-closet-server.vercel.app/orders/${oid}`, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            return response.json();
          })
          .then((data) => {
            console.log("Item deleted successfully!"); // Handle the response data
            // Perform any additional actions after successful deletion
            toast.success("Order deleted successfully!", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 1000,
            });
            // Remove the deleted order from yourData array
            setOrders((prevOrders) => prevOrders.filter((order) => order.oid !== oid));
          })
          .catch((error) => {
            console.error(error); // Handle the error
            if (retryCount < maxRetries) {
              // Retry the DELETE request with exponential backoff
              const retryDelay = 1000 * Math.pow(2, retryCount);
              retryCount++;
              console.warn(`Retrying in ${retryDelay} milliseconds...`);
              setTimeout(executeDelete, retryDelay);
            } else {
              // Maximum retry attempts reached, display an error message
              toast.error("Error deleting the order. Please try again later.", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 3000,
              });
            }
          });
      };
  
      // Start the initial delete attempt
      executeDelete();
    }
  };


  return (
<section style={{ minHeight: `calc(100vh - 100px)` }}>
  {orders?.length > 0 ? ( 
  <div className="container mx-auto mb-3">
  <div className="flex justify-center items-center">
    <div className="max-w-full overflow-x-auto">
      <h1 className="text-2xl font-bold mb-4 text-center">Orders Made</h1>
      <table className="table-auto border border-yellow-500 mx-2 shadow-lg">
        <thead className=''>
          <tr className="bg-slate-300">
            {/* <th className="p-2 md:p-3 border border-yellow-500">Customer Name</th> */}
            <th className="p-2 md:p-3 border border-yellow-500">Phone Number</th>
            <th className="p-2 md:p-3 border border-yellow-500">Ordered Items</th>
            <th className="p-2 md:p-3 border border-yellow-500">Delivery Location</th>
            <th className="p-2 md:p-3 border border-yellow-500">Order Date</th>
            <th className="p-2 md:p-3 border border-yellow-500">Withdraw</th>
          </tr>
        </thead>
        <tbody>
          {orders?.length > 0 ? (
            orders.map((order) => (
              <tr key={order.oid}>
                {/* <td className='border border-yellow-500 bg-blue-200 p-2  md:p-3 '>{order?.full_name}</td> */}
                <td className='border border-yellow-500 bg-blue-200 p-2 md:p-3 '>0{order?.phone_number}</td>
                <td className='border border-yellow-500 bg-blue-200 p-2 md:p-3 '>{order?.product_name}</td>
                <td className='border border-yellow-500 bg-blue-200 p-2 md:p-3 '>{order?.derivery_location}</td>
                <td className='border border-yellow-500 bg-blue-200 p-2 md:p-3 '>{order?.order_date.slice(0, 10)} </td>
                <td className='border border-yellow-500 bg-blue-200 p-2 md:p-3 '>
                    <button onClick={()=>handleDelete(order.oid)} className="border text-red-600 border-gray-400 rounded-md text-sm flex items-center px-2 cursor-pointer hover:bg-red-100 shadow-xl">
                            <span className="mr-2">
                                <AiFillDelete />
                            </span>Delete
                    </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" className='text-center p-10 font-bold'>You have not made any order yet.<Link className='underline text-blue-500' to="/households">Visit market</Link></td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
    </div>
  </div>):(
   <div style={{minHeight: `calc( 100vh - 100px)`}} className='flex justify-center items-center'>
   <h1 className='text-center font-bold'>
     You have not made any order yet.
     <Link className='underline text-blue-500' to="/households">Visit market</Link>
   </h1>
 </div>
  )}
   <ToastContainer />
</section>
  );
};

export default BuyerOrders;
 